








































































































import Vue from 'vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import { CoToastItem, subscribeToToasts } from '@/utils/toastBus';
// import notificationSoundFile from '@/assets/notificationSounds/Notification.wav';

export default Vue.extend({
    name: 'CoToastStack',
    components: {
        CoHeadline,
        CoIcon,
        CoText,
    },
    data() {
        return {
            toasts: [] as CoToastItem[],
            dismissTimers: {} as Record<string, number>,
            unsubscribeFromToasts: null as null | (() => void),
            notificationSound: null as HTMLAudioElement | null,
        };
    },
    created() {
        // Subscribe once at app level so any view can push toasts through the shared bus.
        this.unsubscribeFromToasts = subscribeToToasts((toast) => {
            this.addToast(toast);
        });
    },
    beforeDestroy() {
        if (this.unsubscribeFromToasts) {
            this.unsubscribeFromToasts();
        }

        (Object.values(this.dismissTimers) as number[]).forEach((timerId) => {
            window.clearTimeout(timerId);
        });
    },
    methods: {
        addToast(toast: CoToastItem) {
            if (toast.to && this.$route.path === toast.to) {
                return;
            }

            if (toast.playsSound) {
                // this.playNotificationSound();
            }

            const nextToasts = [toast, ...this.toasts].slice(0, 4);
            const removedToastIds = this.toasts
                .filter((existingToast) => !nextToasts.some((nextToast) => nextToast.id === existingToast.id))
                .map((removedToast) => removedToast.id);

            this.toasts = nextToasts;
            removedToastIds.forEach((toastId) => {
                this.clearDismissTimer(toastId);
            });

            if (this.dismissTimers[toast.id]) {
                window.clearTimeout(this.dismissTimers[toast.id]);
            }

            // Keep the queue self-cleaning so callers do not need to manage toast lifecycle.
            this.dismissTimers[toast.id] = window.setTimeout(() => {
                this.dismissToast(toast.id);
            }, toast.duration);
        },
        dismissToast(toastId: string) {
            this.toasts = this.toasts.filter((toast) => toast.id !== toastId);
            this.clearDismissTimer(toastId);
        },
        handleToastClick(toast: CoToastItem) {
            if (toast.to && this.$route.path !== toast.to) {
                this.$router.push(toast.to);
            }

            this.dismissToast(toast.id);
        },
        clearDismissTimer(toastId: string) {
            if (this.dismissTimers[toastId]) {
                window.clearTimeout(this.dismissTimers[toastId]);
                delete this.dismissTimers[toastId];
            }
        },
        formatTimestamp(timestamp: number) {
            return new Intl.DateTimeFormat(this.$i18n.locale || 'en', {
                hour: '2-digit',
                minute: '2-digit',
            }).format(new Date(timestamp));
        },
        // playNotificationSound() {
        //     if (typeof window === 'undefined' || typeof Audio === 'undefined') {
        //         return;
        //     }

        //     if (!this.notificationSound) {
        //         this.notificationSound = new Audio(notificationSoundFile);
        //         this.notificationSound.preload = 'auto';
        //     }

        //     this.notificationSound.currentTime = 0;
        //     this.notificationSound.play().catch(() => {});
        // },
        getToastAriaLabel(toast: CoToastItem) {
            return `${toast.title} ${toast.message}`.trim();
        },
    },
});
